import {
  ANNOTATION_CHANGED_EVENT,
  ANNOTATIONS_LOADED_EVENT,
  ANNOTATION_SELECTED_EVENT,
  DOCUMENT_LOADED_EVENT,
  PAGE_COMPLETE_EVENT,
  TEXT_SELECTED_EVENT,
} from '../constants/pdf-annotations'

class PDFTronAnnotationsListener {
  constructor(pdfTronInstance, pdfAnnotationsManager) {
    const { annotationManager, documentViewer } = pdfTronInstance.Core

    this.annotationManager = annotationManager
    this.documentViewer = documentViewer

    this.pdfAnnotationsManager = pdfAnnotationsManager
    this.fetchAnnotations = this.pdfAnnotationsManager.fetchAnnotations
  }

  setup() {
    this.pdfAnnotationsManager.setup()
    this._setupAnnotationsEventListeners()
    this._setupEventHubListeners()
  }

  cleanup() {
    ;[
      ANNOTATIONS_LOADED_EVENT,
      ANNOTATION_CHANGED_EVENT,
      ANNOTATION_SELECTED_EVENT,
      DOCUMENT_LOADED_EVENT,
      PAGE_COMPLETE_EVENT,
      TEXT_SELECTED_EVENT,
    ].forEach((event) => {
      this.annotationManager.removeEventListener(event)
    })

    window.eventHub.$off(
      'refreshCommunicationData',
      this.pdfAnnotationsManager.fetchAnnotations
    )
    window.eventHub.$off(
      'refreshCommunicationData',
      this.pdfAnnotationsManager.handleDeletedAnnotation
    )
    window.eventHub.$off(
      'selectPdfAnnotation',
      this.pdfAnnotationsManager.ensureFocusAnnotation
    )
    window.eventHub.$off(
      'clearAnchor',
      this.pdfAnnotationsManager.deselectAllAnnotations
    )
    window.eventHub.$off(
      'modal-closed',
      this.pdfAnnotationsManager.handleRemarkModalClosed
    )
  }

  _setupEventHubListeners() {
    window.eventHub.$on(
      'refreshCommunicationData',
      this.pdfAnnotationsManager.fetchAnnotations
    )
    window.eventHub.$on(
      'refreshCommunicationData',
      this.pdfAnnotationsManager.handleDeletedAnnotation
    )
    window.eventHub.$on(
      'selectPdfAnnotation',
      this.pdfAnnotationsManager.ensureFocusAnnotation
    )
    window.eventHub.$on(
      'clearAnchor',
      this.pdfAnnotationsManager.deselectAllAnnotations
    )
    window.eventHub.$on(
      'modal-closed',
      this.pdfAnnotationsManager.handleRemarkModalClosed
    )
  }

  _setupAnnotationsEventListeners() {
    this.documentViewer.addEventListener(ANNOTATIONS_LOADED_EVENT, () => {
      this.pdfAnnotationsManager.handleAnnotationsLoaded()
    })

    this.documentViewer.addEventListener(
      TEXT_SELECTED_EVENT,
      (quads, _text, pageNumber) => {
        this.pdfAnnotationsManager.handleTextSelected({ quads, pageNumber })
      }
    )

    this.documentViewer.addEventListener(DOCUMENT_LOADED_EVENT, () => {
      this.pdfAnnotationsManager.handleDocumentLoaded()
    })

    this.documentViewer.addEventListener(
      PAGE_COMPLETE_EVENT,
      (pageNumber, canvas) => {
        this.pdfAnnotationsManager.handlePageComplete(pageNumber, canvas)
      }
    )

    this.annotationManager.addEventListener(
      ANNOTATION_CHANGED_EVENT,
      async (annotations, action, { imported }) => {
        await this.pdfAnnotationsManager.handleAnnotationChanged({
          annotations,
          action,
          imported,
        })
      }
    )

    this.annotationManager.addEventListener(
      ANNOTATION_SELECTED_EVENT,
      (annotations, action) => {
        this.pdfAnnotationsManager.handleAnnotationSelected({
          annotations,
          action,
        })
      }
    )
  }
}

export default PDFTronAnnotationsListener
